export default {"src":"/_next/static/media/icon-walletconnect.5bbd2570.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};